import { render, staticRenderFns } from "./ReportingPostTypes.vue?vue&type=template&id=3a5971ae&scoped=true&"
import script from "./ReportingPostTypes.vue?vue&type=script&lang=js&"
export * from "./ReportingPostTypes.vue?vue&type=script&lang=js&"
import style0 from "./ReportingPostTypes.vue?vue&type=style&index=0&id=3a5971ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5971ae",
  null
  
)

export default component.exports